import React, { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../redux/actions/sidebarActions";
import { loanDrilldownSidebarTypes } from "../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { Button } from "@mui/material";
import { AddRounded } from "@mui/icons-material";

const LoanDrilldownButtonAddSpecialCondition = memo(
  ({ size = "small", sx }) => {
    const dispatch = useDispatch();

    const onAdd = useCallback(() => {
      dispatch(
        sidebarTypeSet(loanDrilldownSidebarTypes.ADD_LOAN_SPECIAL_CONDITION)
      );
      dispatch(sidebarSetStateValue(null));
    }, [dispatch]);

    return (
      <Button
        size={size}
        sx={sx}
        variant="text"
        endIcon={<AddRounded className="thin" fontSize="small" />}
        onClick={onAdd}
      >
        Add Special Condition
      </Button>
    );
  }
);
export default LoanDrilldownButtonAddSpecialCondition;
